<template>
  <div class="fff">
    <div class="page_title">{{$t('canYou.title')}}</div>
    <div class="page_bo_li">
      <img
        @click="isshow = 1"
        v-if="isshow != 1"
        src="@/assets/img/qnodui.png"
        alt=""
        class="system_logo"
      />
      <img
        @click="isshow = 0"
        v-if="isshow == 1"
        src="@/assets/img/qdui.png"
        alt=""
        class="system_logo"
      />
      <div class="system_title">{{$t('canYou.yes')}}</div>
      <div class="system_con">{{$t('canYou.yesTips')}}</div>
    </div>
    <div class="page_bo_li">
      <img
        @click="isshow = 2"
        v-if="isshow != 2"
        src="@/assets/img/qnodui.png"
        alt=""
        class="system_logo"
      />
      <img
        @click="isshow = 0"
        v-if="isshow == 2"
        src="@/assets/img/qdui.png"
        alt=""
        class="system_logo"
      />
      <div class="system_title">{{$t('canYou.no')}}</div>
      <div class="system_con">{{$t('canYou.noTips')}}</div>
    </div>
    <div class="twoButton">
      <div class="BackButton">{{$t('canYou.start')}}</div>
      <div class="loginButton">{{$t('canYou.start')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      isshow: 0,
      msg: ''
    }
  },
  mounted () {},
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.page_bo_li {
  margin-bottom: 20px;
  position: relative;
  padding: 25px 0;
  cursor: pointer;
}
.system_logo {
  float: left;
  width: 20px;
  margin: 10px 15px 0 20px;
}
.system_more {
  position: absolute;
  width: 16px;
  height: 16px;
  right: 25px;
  top: 40px;
}
.system_title {
  font-size: 14px;
  height: 16px;
  line-height: 16px;
  font-weight: 700;
  margin-bottom: 5px;
}
.system_con {
  font-size: 13px;
  height: 20px;
  line-height: 20px;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/CanYou.vue